<template>
  <v-row
    class="pa-5"
    no-gutters
    style="flex-wrap: nowrap;"
    @click="$emit('click')">
    <v-col class="d-inline-flex justify-start flex-grow-1 flex-shrink-0 ">
      <div v-if="categories && categories.length">
        <div class="h7-text-medium black--text">
          <div>{{ $t('Tenders.AllSubscribersForSomeCats') }}:</div>
          <div>{{ main_category.code }} {{ main_category.title }} </div>
        </div>
        <div class="h8-text secondary__green_not_active--text mt-3">
          <div> {{ $t('Tenders.AdditionalCategories') }}</div>
          <div
            v-for=" (item, n) in categories"
            :key="n">
            {{ parseInt(item.title) ? item.title : item.code + ' ' + item.title }}
          </div>
        </div>
      </div>
      <div
        v-else
        class="h4-headline">
        {{ $t('Tenders.AllSubscribers') }}
      </div>
    </v-col>
    <v-col class="d-inline-flex justify-end secondary__green_not_active--text text-end h7-text-medium flex-grow-0 flex-shrink-0">
      {{ subscribersCount }}
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'allSubscribers',
  props: {
    subscribersCount: [Number, String],
    categories: Array,
    main_category: Object
  },
}
</script>
<style lang="scss" scoped>
  div {
    text-align: start;
  }
</style>
